<template>
    <div id="attachmentPicker">
        <!-- Picker icons (visible) -->
        <svg-icon
            icon="add-image"
            fill="#FF5500"
            height="50px"
            width="50px"
            class="attachmentPicker__pick-icon"
            v-on:click="openPicker('image')"
        />
        <svg-icon
            icon="add-video"
            fill="#FF5500"
            height="50px"
            width="50px"
            class="attachmentPicker__pick-icon"
            v-on:click="openPicker('video')"
        />
        <svg-icon
            icon="add-audio"
            fill="#FF5500"
            height="50px"
            width="50px"
            class="attachmentPicker__pick-icon"
            v-on:click="openPicker('audio')"
        />
        <svg-icon
            icon="add-file"
            fill="#FF5500"
            height="50px"
            width="50px"
            class="attachmentPicker__pick-icon"
            v-on:click="openPicker('file')"
        />
        <!-- Actual buttons (hidden) -->
        <input
            type="file"
            accept="image/*"
            capture
            id="attachmentPicker__image-picker"
            class="attachmentPicker__hidden-input"
            v-on:change="openPreviewer"
        />
        <input
            type="file"
            accept="video/*"
            capture
            id="attachmentPicker__video-picker"
            class="attachmentPicker__hidden-input"
            v-on:change="openPreviewer"
        />
        <input
            type="file"
            accept="audio/*"
            capture
            id="attachmentPicker__audio-picker"
            class="attachmentPicker__hidden-input"
            v-on:change="openPreviewer"
        />
        <input
            type="file"
            id="attachmentPicker__file-picker"
            class="attachmentPicker__hidden-input"
            v-on:change="openPreviewer"
        />
    </div>
</template>

<script>
import SvgIcon from "@/components/SvgIcon.vue";

export default {
    name: "AttachmentPicker",
    components: {
        SvgIcon
    },
    methods: {
        openPicker(input) {
            let element = "attachmentPicker__" + input + "-picker";
            document.getElementById(element).click();
        },
        openPreviewer(event) {
            this.$emit('filePicked', event);
        }
    }
};
</script>

<style lang="scss" scoped>
$picker__text--font: "Lato";

#attachmentPicker {
    position: relative;
    bottom: 150px;
    width: 300px;
    box-sizing: border-box;
    background-color: #f1f1f1;
    box-shadow: 0 3px 6px -2px rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    padding: 16px;
    font-family: $picker__text--font;
    margin: auto;
    display: flex;
    justify-content: space-around;

    .attachmentPicker__pick-icon {
    }

    .attachmentPicker__hidden-input {
        display: none;
    }
}

/* Smartphones (portrait and landscape) ----------- */

@media only screen and (min-device-width: 320px) and (max-device-width: 599px) {
    #attachmentPicker {

    }
}

/* Tablet (portrait) ----------- */

@media only screen and (min-device-width: 600px) and (max-device-width: 899px) {
    #attachmentPicker {

    }
}

/* Tablet (landscape) ----------- */

@media only screen and (min-device-width: 900px) and (max-device-width: 1199px)  {
    #attachmentPicker {

    }
}

// Desktop versions start here ------------------------------------------------------------------------------------------
/* Desktop ----------- */

@media only screen and (min-device-width: 1200px) and (max-device-width: 1799px)  {
    #attachmentPicker {

    }
}

/* Large desktop ----------- */

@media only screen and (min-device-width: 1800px)  {
    #attachmentPicker {
       
    }
}
</style>